import React, { useMemo, useState } from "react";
import {
  Badge,
  Card,
  CardBody,
  CardHeader,
  HStack,
  Heading,
  Select,
  SkeletonText,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import EmptyState from "./EmptyState";

const CustomersTable = ({ customers, isLoading, formatDateTime }) => {
  const [statusFilter, setStatusFilter] = useState("all");

  const filteredCustomers = useMemo(() => {
    if (statusFilter === "active") {
      return customers.filter((customer) => customer.activeCount > 0);
    }
    if (statusFilter === "inactive") {
      return customers.filter((customer) => customer.activeCount === 0);
    }
    return customers;
  }, [customers, statusFilter]);

  return (
    <Card variant="outline" _hover={{ boxShadow: "md" }} transition="box-shadow 0.2s ease">
      <CardHeader>
        <HStack justify="space-between" flexWrap="wrap" gap={3}>
          <Heading size="sm">Subscription Customers</Heading>
          <HStack spacing={3}>
            <Select
              size="sm"
              value={statusFilter}
              onChange={(event) => setStatusFilter(event.target.value)}
            >
              <option value="all">All statuses</option>
              <option value="active">Active</option>
              <option value="inactive">Inactive</option>
            </Select>
            <Text fontSize="sm" color="gray.500">
              {filteredCustomers.length} records
            </Text>
          </HStack>
        </HStack>
      </CardHeader>
      <CardBody>
        {isLoading ? (
          <SkeletonText noOfLines={6} spacing="3" />
        ) : filteredCustomers.length === 0 ? (
          <EmptyState title="No customers yet" description="Customers appear once subscriptions are created." />
        ) : (
          <TableContainer>
            <Table size="sm">
              <Thead>
                <Tr>
                  <Th>Customer</Th>
                  <Th>Stripe ID</Th>
                  <Th>Subscriptions</Th>
                  <Th>Status</Th>
                  <Th>Last Updated</Th>
                </Tr>
              </Thead>
              <Tbody>
                {filteredCustomers.map((customer) => (
                  <Tr key={customer.id}>
                    <Td>
                      <Text fontWeight="semibold">{customer.name || "-"}</Text>
                      <Text fontSize="xs" color="gray.500">
                        {customer.email}
                      </Text>
                    </Td>
                    <Td>{customer.stripeCustomerId || "-"}</Td>
                    <Td>{customer.subscriptionCount}</Td>
                    <Td>
                      <Badge colorScheme={customer.activeCount > 0 ? "green" : "orange"}>
                        {customer.activeCount > 0 ? "ACTIVE" : "INACTIVE"}
                      </Badge>
                    </Td>
                    <Td>{formatDateTime(customer.updatedAt)}</Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>
          </TableContainer>
        )}
      </CardBody>
    </Card>
  );
};

export default CustomersTable;
